export const GET_METHOD = 'GET'
export const POST_METHOD = 'POST'
